// A simple in-memory logger with subscription capabilities.
const MAX_LOGS = 100;
let logId = 1;
let logs = [];
let subscribers = [];

const logger = {
  log: (level, message, data = {}) => {
    const logEntry = {
      id: logId++,
      timestamp: new Date().toISOString(),
      level, // "info" | "warn" | "error" | "success"
      message,
      ...data,
    };

    logs.push(logEntry);
    if (logs.length > MAX_LOGS) {
      logs.shift();
    }

    // Notify subscribers
    const logsCopy = [...logs];
    subscribers.forEach(callback => callback(logsCopy));

    // Also log to console for standard debugging
    const consoleMethod = console[level] || console.log;
    consoleMethod(`[${level.toUpperCase()}] ${message}`, data);
    
    return logEntry.id;
  },

  info: (message, data) => logger.log('info', message, data),
  warn: (message, data) => logger.log('warn', message, data),
  error: (message, data) => logger.log('error', message, data),
  success: (message, data) => logger.log('success', message, data),
  
  logRequest: (api, method, url, requestData) => {
    return logger.info(`[API Request] ${method} ${url}`, {
      api,
      type: 'request',
      method,
      url,
      request: requestData,
    });
  },
  
  updateLog: (id, data) => {
    const logIndex = logs.findIndex(l => l.id === id);
    if (logIndex > -1) {
      logs[logIndex] = { ...logs[logIndex], ...data };
      const logsCopy = [...logs];
      subscribers.forEach(callback => callback(logsCopy));
    }
  },

  logResponse: (id, status, responseData, duration, headers) => {
    const level = status >= 400 ? 'error' : 'success';
    logger.updateLog(id, { level, status, response: responseData, duration, headers, type: 'response' });
    console[level](`[API Response] Status: ${status} | Duration: ${duration}ms`, { response: responseData });
  },

  logError: (id, error, status) => {
    logger.updateLog(id, { level: 'error', error: error.message || error, status, type: 'response' });
    console.error(`[API Error]`, { error });
  },

  getLogs: () => [...logs],
  
  subscribe: (callback) => {
    subscribers.push(callback);
    callback([...logs]); // Immediately send current logs
    return () => { // Unsubscribe function
      subscribers = subscribers.filter(sub => sub !== callback);
    };
  },
  
  clear: () => {
    logs = [];
    logId = 1;
    const logsCopy = [...logs];
    subscribers.forEach(callback => callback(logsCopy));
  },
};

export default logger;